import { render, staticRenderFns } from "./ScoresTab.vue?vue&type=template&id=256df8be"
import script from "./ScoresTab.vue?vue&type=script&lang=js"
export * from "./ScoresTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports